var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeatmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3351 61.2964H8.81079C7.70622 61.2964 6.81079 60.401 6.81079 59.2964V10.7559C6.81079 9.65129 7.70622 8.75586 8.81079 8.75586H57.3513C58.4559 8.75586 59.3513 9.65129 59.3513 10.7559V34.0045",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7392 62.694V52.0117C67.7392 50.9071 66.8438 50.0117 65.7392 50.0117H46.7567C45.6521 50.0117 44.7567 50.9071 44.7567 52.0117V62.694",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4324,
    cy: 41.8372,
    r: 3.89189,
    fill: "#CCCFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5946 44.2702L28.2162 30.6485L35.027 37.4594L48.1622 24.3242",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4054 23.3516H49.1351V33.0813",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeatmap);
export default __webpack_public_path__ + "static/media/icon-heatmap.21b3e11819a71fdcc6b2c739dfd058b0.svg";
export { ForwardRef as ReactComponent };